// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3ZYKC","footer":"ModalFilter_footer__9EyMd"};